import { clearEstablishedAuth0Sub } from './sync-auth-session';

const LOGGING_OUT_SESSION_KEY = 'lift-logging-out';
export const BACKEND_SESSION_VALIDATED_KEY = 'lift-backend-session-validated';
/** How long to skip redundant /auth/me/ checks after a successful validation. */
const BACKEND_SESSION_VALIDATED_TTL_MS = 5 * 60 * 1000;

let isHandlingUnauthorized = false;

export function markLoggingOut(): void {
  sessionStorage.setItem(LOGGING_OUT_SESSION_KEY, '1');
}

export function isLoggingOutSession(): boolean {
  return sessionStorage.getItem(LOGGING_OUT_SESSION_KEY) === '1';
}

export function resetAuthSessionFlags(): void {
  sessionStorage.removeItem(LOGGING_OUT_SESSION_KEY);
  sessionStorage.removeItem(BACKEND_SESSION_VALIDATED_KEY);
  clearEstablishedAuth0Sub();
  isHandlingUnauthorized = false;
}

/** Skip redundant /auth/me/ checks immediately after a successful login or SSO init. */
export function markBackendSessionValidated(): void {
  sessionStorage.setItem(
    BACKEND_SESSION_VALIDATED_KEY,
    String(Date.now())
  );
}

function getBackendSessionValidatedAt(): number | null {
  const raw = sessionStorage.getItem(BACKEND_SESSION_VALIDATED_KEY);
  if (!raw) {
    return null;
  }

  const validatedAt = Number(raw);
  return Number.isNaN(validatedAt) ? null : validatedAt;
}

export function hasBackendSessionEverValidated(): boolean {
  return getBackendSessionValidatedAt() !== null;
}

export function isBackendSessionRecentlyValidated(): boolean {
  const validatedAt = getBackendSessionValidatedAt();
  if (validatedAt === null) {
    return false;
  }

  return Date.now() - validatedAt < BACKEND_SESSION_VALIDATED_TTL_MS;
}

export function clearBackendSessionValidated(): void {
  sessionStorage.removeItem(BACKEND_SESSION_VALIDATED_KEY);
}

/** Returns true only for the first unauthorized response in a burst. */
export function shouldHandleUnauthorized(): boolean {
  if (isLoggingOutSession() || isHandlingUnauthorized) return false;
  isHandlingUnauthorized = true;
  return true;
}

/** Allows a retried request after a successful Soul Map silent session refresh. */
export function resetUnauthorizedHandling(): void {
  isHandlingUnauthorized = false;
}
